import { render, staticRenderFns } from "./ApprenticeDashboardView.vue?vue&type=template&id=44d31626&scoped=true&"
import script from "./ApprenticeDashboardView.ts?vue&type=script&lang=js&"
export * from "./ApprenticeDashboardView.ts?vue&type=script&lang=js&"
import style0 from "./ApprenticeDashboardView.css?vue&type=style&index=0&id=44d31626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d31626",
  null
  
)

export default component.exports